<div class="block p-5 max-w-7xl mx-auto shadow-md">
  <!-- Main content area -->
  <div class="flex">
    <div class="flex-1 p-5 bg-white rounded mr-5">
      <!-- User header -->
      <div class="mb-8">
        <h2 class="text-2xl mb-2 font-medium">{{ user.firstName }} {{ user.lastName }}</h2>
        <div class="text-gray-600 text-sm">
          <p class="my-1">
            Created By: {{ user.createdBy?.firstName }} {{ user.createdBy?.lastName }}
          </p>
          <p class="my-1">Created On: {{ user.dateCreated | date: 'MM/dd/yyyy hh:mma' }}</p>
        </div>
      </div>

      <!-- User info -->
      <div class="mb-8">
        <div class="my-4">
          <span>Email: </span>
          <span>{{ user.email }}</span>
        </div>
        <div class="my-4">
          <span>Title: </span>
          <span>{{ user.title }}</span>
        </div>
        <div class="my-4">
          <span>Fax Number: </span>
          <span>{{ user.faxNumber || 'N/A' }}</span>
        </div>
      </div>

      <!-- User permissions -->
      <form [formGroup]="userForm">
        <div class="mb-8 flex items-center flex-col">
          <label class="block mb-2">User Permission</label>
          <mat-radio-group formControlName="roles" class="flex flex-col">
            @for (role of roles; track role.key) {
              <mat-radio-button [value]="role.key" [disabled]="true">
                {{ role.value }}
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>
      </form>
    </div>

    <!-- Options panel -->
    <div *ciwcRoleAccess="['ROLE_SUPER_ADMIN']" class="w-64">
      <div class="bg-white rounded shadow-md p-4">
        <h3 class="text-gray-600 font-normal mb-4 pb-2">Options</h3>

        <div class="py-3 flex justify-between items-center">
          <button
            class="w-100 flex items-center space-x-2 text-gray-700 hover:text-blue-500"
            [routerLink]="'/users/edit/' + user.id"
          >
            <span>Edit Details</span>
          </button>
          <button class="w-100 flex items-center space-x-2" [routerLink]="'/users/edit/' + user.id">
            <mat-icon>edit</mat-icon>
          </button>
        </div>

        <div
          class="py-3 flex justify-between items-center cursor-pointer hover:text-blue-500"
          (click)="changeUserStatus()"
        >
          <span>{{ isStatusActive ? 'Archive' : 'Unarchive' }} User</span>
          <mat-icon class="text-gray-600">delete</mat-icon>
        </div>

        <div
          class="py-3 flex justify-between items-center cursor-pointer hover:text-blue-500"
          (click)="resetPassword()"
        >
          <span>Reset Password</span>
          <mat-icon class="text-gray-600">refresh</mat-icon>
        </div>
      </div>
    </div>
  </div>

  <!-- Action buttons -->
  <div class="flex justify-end mt-10">
    <button mat-flat-button [routerLink]="'/users'" class="text-blue-500">CANCEL</button>
  </div>
</div>
